import { FC } from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Navigate } from 'react-router';
import { ApplicantProfileApplyToViewContainer } from '../components/applicant-profile-apply-to-view.container';
import { ApplicantProfileApplyToEditContainer } from '../components/applicant-profile-apply-to-edit.container';

export const ApplicantProfileApplyTo: FC = () => {
  const params = useParams();
  const applicantId = params?.applicantId ?? '';

  return (
    <div>
      <Helmet>
        <title>Applicant - Apply To</title>
      </Helmet>
      <Routes>
        <Route index element={<Navigate to="view" replace />} />
        <Route path="view/*" element={<ApplicantProfileApplyToViewContainer applicantId={applicantId} />} />
        <Route path="edit/*" element={<ApplicantProfileApplyToEditContainer applicantId={applicantId} />} />
      </Routes>
    </div>
  );
};
